import { Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Home from "./Home";
import About from "./About";
import Services from "./Services";
import Clients from "./Clients";
import Billboards from "./Billboards";
import Contact from "./Contact";
// import Sidebar from "./Dashboard/Sidebar";
import DashboardLayout from "./Dashboard/DashboardLayout";
import Messages from "./Dashboard/Messages";
import AddBillboard from "./Dashboard/AddBillboard";
import AddClient from "./Dashboard/AddClient";
import Bookings from "./Dashboard/Bookings";
import Login from "./Dashboard/Login";
import Address from "./Dashboard/Address";

function App() {
  // هنا نعمل الفنكشن اللي تمنع الدخول من غير لوجين
  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <div className="App">
      <Routes>
        {/* public pages */}
        <Route path="/" element={<Home />} />
        <Route path="home" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="services" element={<Services />} />
        <Route path="billboards" element={<Billboards />} />
        <Route path="clintes" element={<Clients />} />
        <Route path="contact" element={<Contact />} />
        <Route path="login" element={<Login />} />

        {/* protected dashboard */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="messages" element={<Messages />} />
          <Route path="add-billboard" element={<AddBillboard />} />
          <Route path="address" element={<Address />} />
          <Route path="add-client" element={<AddClient />} />
          <Route path="bookings" element={<Bookings />} />
          {/* <Route path="*" element={<NotFound />} /> */}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
